var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('prd-loader',{staticClass:"mt-5 mx-auto"}),_c('h2',[_vm._v("Loading..")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }